import createReactClass from 'create-react-class';
import Autosuggest from "react-autosuggest";

const tools = require('form/tools')();

export default function(dependencies) {

    const TextField = createReactClass({
        render() {
            var field = this.props.field;
            var InputField = dependencies.InputField;
            var {config} = field;

            return  <div className="lz-input-wrapper">
                <label htmlFor={dependencies.tools.uniqueId(field.config.id)}>{field.config.label}</label>
                <span className="lz-extratext">{field.config.tinyLabel}</span>
                <Autosuggest 
                    suggestions={this.state.suggestions}
                    onSuggestionsClearRequested={onSuggestionsClearRequested.bind(this)}
                    onSuggestionsFetchRequested={onSuggestionsFetchRequested.bind(this)}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion.bind(null, field)}
                    renderInputComponent={this.renderInputComponent}
                    inputProps={{
                        placeholder: config.placeholder,
                        value: field.state.value,
                        onChange: onChange.bind(this),
                    }}
                />
            </div>;
        },
        renderInputComponent(inputProps) {
            var InputField = dependencies.InputField;
            var field = this.props.field;


            return <div>
                <div className={`lz-input ${this.props.errorClass} ${(field.config.style && field.config.style.lz_input) || ""}`} >
                    <div className={this.props.spinnerClass} >
                        <i className="fa fa-spinner fa-spin"></i>
                    </div>
                    <div className="lz-checkmark">
                        <i className="fa fa-check"></i>
                    </div>
                    <input {...inputProps} onBlur={onBlur.bind(this, inputProps)} />
                    <span className="lz-input-bar"></span>
                </div>
                {this.props.errors}
            </div>;

        },
        getInitialState() {
            return {
                suggestions: []
            };
        }
    });

    return {
        html: TextField,
        config: {
            "behaviour": "text-input",
        },
    };
};

function onBlur(inputProps, ...args) {
    var oldSuggestions = this.state.suggestions;
    if (oldSuggestions.length === 1) {
        onChange.bind(this)(null, {newValue: oldSuggestions[0]});
    }
    inputProps.onBlur.apply(this, args);
}

function getSuggestions({config, state}, argument) {
    var {suggestionKey} = config;
    var {liveReference} = state;
    return liveReference.feed.map(row => {
        var left = String(row[suggestionKey]).toLowerCase();
        var right = argument.toLowerCase();
        var index = left.indexOf(right);
        return [index, left, row];
    }).filter(([index]) => index !== -1).sort((a,b) => {
        var [leftIndex, leftName] = a;
        var [rightIndex, rightName] = b;
        if (leftIndex !== rightIndex) return leftIndex - rightIndex;
        else if (leftName < rightName) return -1;
        else return 1;
    }).map(([_1, _2, row]) => row).slice(0,5);
}

function renderSuggestion({config, state}, row) {
    var {value} = state;
    var suggestionValue = row[config.suggestionKey];
    var matches = suggestionValue.split(new RegExp(value, "i"));
    // var old = <div>
    //     {matches.map((match, index) => {
    //         return <div style={{display: "inline-block"}}>
    //             {match}
    //             {index !== matches.length -1 ?  <strong>{value}</strong> : null}
    //         </div>;
    //     })}
    // </div>;

    return <div>{suggestionValue}</div>;
}


function getSuggestionValue(arg) {
    return arg;
}

function onSuggestionsClearRequested() {

    this.setState({
        suggestions: []
    });
}

function onSuggestionsFetchRequested({value}) {
    this.setState({
        suggestions: getSuggestions(this.props.field, value)
    });
}


function onChange(event, input) {

    var field = this.props.field;
    var {config, state} = field;
    var {newValue} = input;

    var feedState = {feed: state.feed};

    if (typeof newValue === "string") {
        state.value = newValue;
        var match = findCompleteMatch(field, newValue) || {};
        setExtraState(field, tools.merge(match, feedState));
    }
    else {
        state.value = newValue[config.suggestionKey];
        setExtraState(field, tools.merge(newValue, feedState));
    }
    this.forceUpdate();
    this.props.onUpdate();

}

function findCompleteMatch({config, state}, value) {
    var {suggestionKey} = config;
    var {liveReference} = state;
    for (var index in liveReference.feed) {
        var row = liveReference.feed[index];
        var left = String(row[suggestionKey]).toLowerCase();
        var right = value.toLowerCase();
        if (left === right) return row;
    }
}


function setExtraState({config, state}, extraState) {
    for (var key in config.extraState) {
        state[key] = extraState[key] || null;
    }
}
